import { Button, Grid, Typography, useTheme } from '@mui/material';
import { get as _get } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import Chevron from '../Chevron';

export default function Accordion(props: any) {
  const theme = useTheme();
  const [isActive, setIsActive] = useState(false); // Use boolean for active state
  const [height, setHeight] = useState('0px');
  const content: React.LegacyRef<HTMLDivElement> = useRef(null);
  const { updateParentOnAccordionChange } = props;
  const toggleAccordion = useCallback(() => {
    setIsActive(!isActive); // Toggle boolean state
    setHeight(isActive ? '0px' : `${_get(content, 'current.scrollHeight', '0')}px`);
    if (updateParentOnAccordionChange) {
      updateParentOnAccordionChange(!isActive);
    }
  }, [isActive, updateParentOnAccordionChange]);

  useEffect(() => {
    if (props.toggleOpen) {
      setIsActive(true);
      setHeight(`${_get(content, 'current.scrollHeight', '0')}px`);
    }
  }, [props.toggleOpen]);

  useEffect(() => {
    if (props.toggleClose) {
      setIsActive(false);
      setHeight(`0px`);
    }
  }, [props.toggleClose]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Button disableRipple onClick={toggleAccordion} sx={theme.custom.styles.accordionHeaderButtonStyle}>
          {theme.custom.styles.chevronFirst && (
            <Grid container spacing={3}>
              <Grid item sx={{ marginTop: '5px' }}>
                <Chevron
                  isActive={isActive}
                  fill={theme.custom.colors.accordionChevronColor}
                  sx={{ paddingLeft: '2rem' }}
                  height={theme.custom.styles.chevronHeight}
                  width={theme.custom.styles.chevronWidth}
                />
              </Grid>
              <Grid item>
                <Typography sx={theme.custom.styles.accordionRowHeader}>{props.title}</Typography>
              </Grid>
            </Grid>
          )}

          {!theme.custom.styles.chevronFirst && (
            <>
              <Typography sx={theme.custom.styles.accordionRowHeader}>{props.title}</Typography>
              <Chevron
                isActive={isActive}
                fill={theme.custom.colors.accordionChevronColor}
                height={theme.custom.styles.chevronHeight}
                width={theme.custom.styles.chevronWidth}
              />
            </>
          )}
        </Button>
      </Grid>
      <div
        style={{
          width: '100%',
          background: isActive && props.needsGradient ? 'linear-gradient(to bottom, #FFFFFF 50%, #F0F2F5 50%)' : '',
        }}
      ></div>
      <div
        ref={content}
        style={{
          maxHeight: `${height}`,
          backgroundColor: 'white',
          overflow: 'hidden',
          width: '100%',
          transition: 'max-height 0.6s ease',
        }}
      >
        <div
          style={{
            fontFamily: theme.custom.styles.titleType1.fontFamily,
            fontWeight: 400,
            fontSize: '16px',
          }}
        >
          {props.component}
        </div>
      </div>
    </Grid>
  );
}
